/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateFriendLabelBody
 */
export interface UpdateFriendLabelBody {
    /**
     * The custom label to set for this friend, or null to clear
     * @type {string}
     * @memberof UpdateFriendLabelBody
     */
    label: string | null;
}

/**
 * Check if a given object implements the UpdateFriendLabelBody interface.
 */
export function instanceOfUpdateFriendLabelBody(value: object): value is UpdateFriendLabelBody {
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function UpdateFriendLabelBodyFromJSON(json: any): UpdateFriendLabelBody {
    return UpdateFriendLabelBodyFromJSONTyped(json, false);
}

export function UpdateFriendLabelBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateFriendLabelBody {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'],
    };
}

export function UpdateFriendLabelBodyToJSON(json: any): UpdateFriendLabelBody {
    return UpdateFriendLabelBodyToJSONTyped(json, false);
}

export function UpdateFriendLabelBodyToJSONTyped(value?: UpdateFriendLabelBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'label': value['label'],
    };
}

